import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import MainMenu from "./Menu.js";
import useStyles from "./Sidebar-jss";
import {
  Badge,
  Box,
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import Fade from "@mui/material/Fade";
import useWebr from "../../../../WebR/hooks/useWebr.js";
import useAuth from "hooks/useAuth";
import { useRcState } from "WebR/system/Provider.js";
import { images } from "utils/Images.js";
import useSystem from "WebR/hooks/useSystem.js";
import CallEndIcon from "@mui/icons-material/CallEnd";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import moment from "moment";
import { getPhoneNumberRequest } from "api/voiceCallMail.js";

const SidebarContent = ({ app, props }) => {
  const classes = useStyles();
  const { initialize, unregister } = useWebr();
  const { data, endCall, setCallData, mute, unmute, hold, unhold } =
    useSystem();
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { callService } = useRcState();
  const [time, setTime] = React.useState("Ringing");
  const [, setShowUI] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState();

  useEffect(() => {
    const fetchPhoneNumber = async () => {
      try {
        const response = await getPhoneNumberRequest();
        setPhoneNumber(response.data);
      } catch (error) {
        console.error("Failed to fetch phone number:", error);
      }
    };
    fetchPhoneNumber();
  }, []);

  const handleClick = (event) => {
    if ("101") {
      setAnchorEl(event.currentTarget);
    }
  };
  useEffect(() => {}, [callService]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [status, setStatus] = React.useState("offline");

  const handleStatus = (status) => {
    setStatus(status);
    if (localStorage.getItem("status") === "offline") {
      initialize(
        {
          name: `${user.data.first_name} ${user.data.last_name}`,
          username: "+18313169191",
          extension: user.data.extension,
          password: user.data.rc_pass,
        },
        () => {}
      );
    } else {
      unregister();
    }
    handleClose();
  };

  useEffect(() => {
    if (localStorage.getItem("status") === "online") {
      initialize(
        {
          name: `${user.data.first_name} ${user.data.last_name}`,
          username: "+18313169191",
          extension: user.data.extension,
          password: user.data.rc_pass,
        },
        () => {}
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (localStorage["rc-platform"]) {
      JSON.parse(localStorage["rc-platform"]);
    } else {
      setTimeout(() => {
        localStorage.setItem("status", "offline");
      }, 1000);
      console.log("You Need To Login!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const getStatusColor = () => {
    if (callService.states === "online") {
      return localStorage.getItem("status") === "online" ? "success" : "";
    }
    return "black";
  };

  const getTitle = () => {
    if (callService.states === "online") {
      return localStorage.getItem("status") === "online"
        ? "You are  receiving calls"
        : "You are  not receiving calls";
    }
    // return "You account does not support calls";
  };

  const startConferenceCall = async () => {
    try {
      await setCallData({
        open: true,
        popopen: false,
      });
      setShowUI(false);
      return true;
    } catch (error) {
      console.error("Error in startConferenceCall", error.stack || error);
      throw error;
    }
  };

  React.useEffect(() => {
    const startTime = data?.session?.startTime;
    const interval = setInterval(() => {
      const currentTime = startTime
        ? Math.round((Date.now() - startTime) / 1000)
        : 0;
      setTime(moment.utc(currentTime * 1000).format("HH:mm:ss"));
    }, 1000);
    setCallData({
      popopen: true,
    });
    return () => clearInterval(interval); // Cleanup the interval on component unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.session]);

  const callendsidba = async () => {
    try {
      await setCallData({
        open: false,
      });
      endCall();

      return true;
    } catch (error) {
      console.error("Error in startConferenceCall", error?.stack || error);
      throw error;
    }
  };

  return (
    <div className={classes.drawerInner}>
      <div className={classes.drawerHeader}>
        <NavLink to="/app" className={classes.brand}>
          <img src={images.loginLogo.url} alt="logo" />
        </NavLink>
      </div>
      <Box pt={3} pl={4} pr={2}>
        <Box display="flex" alignItems="center">
          <Box
            position="relative"
            display="flex"
            alignItems="center"
            sx={{
              background: user?.data?.bgColor,
              color: user?.data?.txtColor,
              borderRadius: "16px",
              padding: "8px 16px",
              minWidth: "100px",
            }}
          >
            <Typography fontWeight="bold">
              {user?.data?.first_name} {user?.data?.last_name}
            </Typography>
            <Badge
              title={getTitle()}
              sx={{
                cursor: "pointer",
                position: "absolute",
                bottom: 0,
                right: 0,
                transform: "translate(50%, 50%)",
                color:"gray"
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              onClick={handleClick}
              overlap="circular"
              badgeContent={
                <ArrowDropDownCircleIcon color={getStatusColor()} />
              }
              variant="standard"
            />
          </Box>
        </Box>
        <Box pl={0} pt={2}>
          <Typography>Main: 1 (831) 316-9191</Typography>
          <Typography>
            {user?.data?.first_name[0]}
            {user?.data?.last_name[0]}:{" "}
            {localStorage.getItem("status") === "online"
              ? phoneNumber?.user_phone
              : ""}
          </Typography>
        </Box>
      </Box>
      {localStorage.getItem("status") === "offline" || "online" ? (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {localStorage.getItem("status") === "offline" && (
            <MenuItem onClick={() => handleStatus("online")}>
              Go Online
            </MenuItem>
          )}
          {localStorage.getItem("status") === "online" && (
            <MenuItem onClick={() => handleStatus("offline")}>
              Go Offline
            </MenuItem>
          )}
          {localStorage.getItem("status") === "online" && (
            <MenuItem onClick={() => handleStatus("break")}>
              Go on Break
            </MenuItem>
          )}
        </Menu>
      ) : null}

      <div
        sx={{ overflow: "scroll" }}
        id="sidebar"
        className={classNames(classes.menuContainer, classes.rounded)}
      >
        <MainMenu app={app} />
      </div>

      {data && data.state === "in-call" && data.popopen && (
        <div className="callingBTNSec_Wrapper">
          <Button className="expantBTN">
            <ArrowOutwardIcon onClick={startConferenceCall} />
          </Button>
          <Typography variant="caption" sx={{ mb: "0px !important" }}>
            Incoming Call
          </Typography>
          <Typography
            variant="caption"
            sx={{
              mt: "0px !important",
              mb: "30",
              fontSize: "14px",
              color: "#515151",
              fontWeight: 600,
              lineHeight: "normal",
              ml: 6,
            }}
          >
            Duration:{" "}
            <span
              style={{
                fontSize: "15px",
                color: "#5B5B5B",
                fontWeight: 400,
                lineHeight: "normal",
              }}
            >
              {time}
            </span>
          </Typography>
          <div className="cstmFlex">
            {data.muted ? (
              <ListItemIcon
                sx={{
                  minWidth: "48px",
                  height: "46px",
                  borderRadius: "50%",
                  backgroundColor: "#116089",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => unmute()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                >
                  <path
                    d="M4.06046 8.06715L3.36636 8.76125C2.90497 8.22887 2.65152 7.54769 2.65271 6.8432V2.9328C2.65271 2.15497 2.9617 1.409 3.51171 0.858997C4.06172 0.30899 4.80769 0 5.58551 0C6.36334 0 7.10931 0.30899 7.65931 0.858997C8.20932 1.409 8.51831 2.15497 8.51831 2.9328V3.61028L7.54071 4.58787V2.9328C7.54071 2.41425 7.33472 1.91694 6.96805 1.55026C6.60138 1.18359 6.10406 0.9776 5.58551 0.9776C5.06696 0.9776 4.56965 1.18359 4.20298 1.55026C3.83631 1.91694 3.63031 2.41425 3.63031 2.9328V6.8432C3.63031 7.30658 3.79162 7.73281 4.06046 8.06715ZM4.85427 8.65664C5.15104 8.77632 5.47265 8.82133 5.79087 8.78772C6.1091 8.75411 6.41421 8.64291 6.67943 8.46387C6.94466 8.28484 7.16188 8.04344 7.31205 7.76087C7.46222 7.4783 7.54073 7.16319 7.54071 6.8432V5.9702L8.51831 4.9926V6.8432C8.51849 7.35762 8.38336 7.86304 8.12648 8.30873C7.8696 8.75443 7.50001 9.12471 7.0548 9.38243C6.60959 9.64015 6.10442 9.77623 5.59 9.77701C5.07558 9.7778 4.57 9.64327 4.124 9.38691L4.85427 8.65664ZM2.57451 10.9364L3.27936 10.2325C3.82383 10.5742 4.45389 10.7549 5.09671 10.7536H6.07431C6.98178 10.7536 7.85207 10.3931 8.49375 9.75143C9.13542 9.10976 9.49591 8.23946 9.49591 7.332V6.8432C9.49591 6.71356 9.54741 6.58923 9.63908 6.49756C9.73074 6.4059 9.85507 6.3544 9.98471 6.3544C10.1143 6.3544 10.2387 6.4059 10.3303 6.49756C10.422 6.58923 10.4735 6.71356 10.4735 6.8432V7.332C10.4735 8.49874 10.01 9.61769 9.18501 10.4427C8.36001 11.2677 7.24105 11.7312 6.07431 11.7312V12.7088H7.05191C7.18155 12.7088 7.30588 12.7603 7.39755 12.852C7.48921 12.9436 7.54071 13.068 7.54071 13.1976C7.54071 13.3272 7.48921 13.4516 7.39755 13.5432C7.30588 13.6349 7.18155 13.6864 7.05191 13.6864H4.11911C3.98948 13.6864 3.86515 13.6349 3.77348 13.5432C3.68181 13.4516 3.63031 13.3272 3.63031 13.1976C3.63031 13.068 3.68181 12.9436 3.77348 12.852C3.86515 12.7603 3.98948 12.7088 4.11911 12.7088H5.09671V11.7312C4.15822 11.7312 3.28815 11.4379 2.57451 10.9364ZM1.83935 10.2892C1.10316 9.48045 0.695892 8.42567 0.697515 7.332V6.8432C0.697515 6.71356 0.749013 6.58923 0.840681 6.49756C0.932349 6.4059 1.05668 6.3544 1.18631 6.3544C1.31595 6.3544 1.44028 6.4059 1.53195 6.49756C1.62362 6.58923 1.67511 6.71356 1.67511 6.8432V7.332C1.67511 8.20011 1.9987 8.99392 2.53149 9.5971L1.83935 10.2892Z"
                    fill="#fff"
                  />
                  <path
                    d="M0.830048 12.9076C0.738253 12.9971 0.614965 13.047 0.486755 13.0465C0.358545 13.0459 0.235679 12.995 0.144636 12.9048C0.0535931 12.8145 0.00166365 12.6921 3.9281e-05 12.5639C-0.00158509 12.4357 0.0472257 12.312 0.135952 12.2194L10.8895 1.3964C10.9813 1.3069 11.1046 1.25704 11.2328 1.25757C11.3611 1.25811 11.4839 1.309 11.575 1.39927C11.666 1.48954 11.7179 1.61197 11.7196 1.74018C11.7212 1.86838 11.6724 1.99208 11.5836 2.08463L0.830048 12.9076Z"
                    fill="#fff"
                  />
                </svg>
              </ListItemIcon>
            ) : (
              <ListItemIcon
                sx={{
                  minWidth: "48px",
                  height: "46px",
                  borderRadius: "50%",
                  backgroundColor: "#EAF8FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => mute()}
              >
                <svg
                  width="12"
                  height="16"
                  viewBox="0 0 12 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.98586 3.05352C7.98586 1.91939 7.04758 1 5.89015 1C4.73272 1 3.79443 1.91939 3.79443 3.05352V7.16057C3.79443 8.29471 4.73272 9.2141 5.89015 9.2141C7.04758 9.2141 7.98586 8.29471 7.98586 7.16057V3.05352Z"
                    stroke="#116089"
                    strokeWidth="1.3"
                    fill="#fff"
                  />
                  <path
                    d="M1 6.47559V7.16009C1 8.43089 1.51519 9.64965 2.43225 10.5482C3.3493 11.4468 4.59309 11.9517 5.89 11.9517M5.89 11.9517C7.18691 11.9517 8.4307 11.4468 9.34775 10.5482C10.2648 9.64965 10.78 8.43089 10.78 7.16009V6.47559M5.89 11.9517V14.6897M5.89 14.6897H3.79429M5.89 14.6897H7.98571"
                    stroke="#116089"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="#fff"
                  />
                </svg>
              </ListItemIcon>
            )}

            <Button className="callingBTN callCustmBtn">
              {data.onHold ? (
                <ListItemIcon
                  sx={{
                    minWidth: "48px",
                    height: "46px",
                    borderRadius: "50%",
                    backgroundColor: "#116089",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => unhold()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                  >
                    <path
                      d="M6.33293 3.1665C6.52683 3.16653 6.71399 3.23772 6.85889 3.36657C7.00379 3.49542 7.09636 3.67297 7.11905 3.86555L7.12459 3.95817V15.0415C7.12437 15.2433 7.04711 15.4374 6.90859 15.5841C6.77007 15.7308 6.58076 15.8191 6.37932 15.8309C6.17789 15.8428 5.97954 15.7772 5.82481 15.6477C5.67008 15.5182 5.57063 15.3345 5.5468 15.1341L5.54126 15.0415V3.95817C5.54126 3.74821 5.62467 3.54684 5.77313 3.39838C5.9216 3.24991 6.12296 3.1665 6.33293 3.1665ZM12.6663 3.1665C12.8602 3.16653 13.0473 3.23772 13.1922 3.36657C13.3371 3.49542 13.4297 3.67297 13.4524 3.86555L13.4579 3.95817V15.0415C13.4577 15.2433 13.3804 15.4374 13.2419 15.5841C13.1034 15.7308 12.9141 15.8191 12.7127 15.8309C12.5112 15.8428 12.3129 15.7772 12.1581 15.6477C12.0034 15.5182 11.904 15.3345 11.8801 15.1341L11.8746 15.0415V3.95817C11.8746 3.74821 11.958 3.54684 12.1065 3.39838C12.2549 3.24991 12.4563 3.1665 12.6663 3.1665Z"
                      fill="#fff"
                    />
                  </svg>
                </ListItemIcon>
              ) : (
                <ListItemIcon
                  sx={{
                    minWidth: "48px",
                    height: "46px",
                    borderRadius: "50%",
                    backgroundColor: "#EAF8FF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => hold()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                  >
                    <path
                      d="M7.33293 3.1665C6.52683 3.16653 6.71399 3.23772 6.85889 3.36657C7.00379 3.49542 7.09636 3.67297 7.11905 3.86555L7.12459 3.95817V15.0415C7.12437 15.2433 7.04711 15.4374 6.90859 15.5841C6.77007 15.7308 6.58076 15.8191 6.37932 15.8309C6.17789 15.8428 5.97954 15.7772 5.82481 15.6477C5.67008 15.5182 5.57063 15.3345 5.5468 15.1341L5.54126 15.0415V3.95817C5.54126 3.74821 5.62467 3.54684 5.77313 3.39838C5.9216 3.24991 6.12296 3.1665 6.33293 3.1665ZM12.6663 3.1665C12.8602 3.16653 13.0473 3.23772 13.1922 3.36657C13.3371 3.49542 13.4297 3.67297 13.4524 3.86555L13.4579 3.95817V15.0415C13.4577 15.2433 13.3804 15.4374 13.2419 15.5841C13.1034 15.7308 12.9141 15.8191 12.7127 15.8309C12.5112 15.8428 12.3129 15.7772 12.1581 15.6477C12.0034 15.5182 11.904 15.3345 11.8801 15.1341L11.8746 15.0415V3.95817C11.8746 3.74821 11.958 3.54684 12.1065 3.39838C12.2549 3.24991 12.4563 3.1665 12.6663 3.1665Z"
                      fill="#116089"
                    />
                  </svg>
                </ListItemIcon>
              )}
            </Button>

            <Button className="callingBTN callingEndBTN" onClick={callendsidba}>
              <CallEndIcon />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarContent;
